/*
 * @Author: Yun
 * @Date: 2023-11-29 15:52:42
 * @Last Modified by: Yun
 * @Last Modified time: 2023-11-30 10:14:02
 */
import React, { useEffect } from 'react'
import greetings_vido from '../../../assets/video/greetings-video.mp4'
import './index.less'

window.jwplayer.key = '44Q5I+IeRJNSOKmj+UHDkKYQrWx3R2iz4Og48gAQJUKRwMOK'

let video_player = null

const Greetings = (props) => {
    useEffect(() => {
        video_player = setJWplayer(document.querySelector('#greetings_video'), {
            video: greetings_vido,
            poster: require('@images/greetings/greetings_cover.jpg'),
        })
    }, [])

    // 播放器
    const setJWplayer = (dom, data, opt) => {
        opt = opt || {}
        let instance

        try {
            instance = window
                .jwplayer(dom)
                .setup({
                    file: data.video,
                    image: data.poster,
                    // skin: {
                    //     name: 'nk-player'
                    // },
                    stretching: 'fill',
                    width: '100%',
                    aspectratio: opt.ratio || '16:9',
                    androidhls: true,
                    primary: 'html5',
                    autostart: opt.autostart === 'true' ? true : false,
                    mute: opt.mute === 'true' ? true : false,
                    controls: opt.controls === 'false' ? false : true,
                    repeat: opt.repeat === 'true' ? true : false,
                    hlshtml: true,
                    base: process.env.PUBLIC_URL + '/jwplayer-8.12.5',
                    flashplayer: process.env.PUBLIC_URL + '/jwplayer-8.12.5/jwplayer.flash.swf',
                })
                .on('setupError', (e) => {
                    console.log('Setup Error...', e)
                })
                .on('play', () => {
                    console.log('video play')
                    props.closeSwiperPageVideo()
                    props.closeAudio()
                    props.closeSecondPageVideo()
                    opt.onPlay && opt.onPlay()
                })
        } catch (error) {
            console.error('Setup JWplayer: ' + error)
        }

        return instance
    }

    return (
        <div className="greetings">
            <div className="greetings-wrapper">
                <div className="big-bg"></div>
                <div className="greetings-title"></div>
                <div className="greetings-video-wrapper">
                    <div className="greetings-video" id={'greetings_video'}></div>
                    {/* <div className="greetings-mask"></div> */}
                </div>
                <div className="text">
                    In a year marked by rising geopolitical tensions and escalating global
                    instability, China's diplomatic efforts in 2024 stood out as a key player in
                    fostering stability.
                    <br />
                    <br />
                    From pushing for the first adoption of a UN Security Council ceasefire
                    resolution in Gaza in March, to facilitating Palestinian reconciliation and the
                    signing of the Beijing Declaration in July, and to lunching with the Global
                    South the "Friends for Peace" for Ukraine crisis, China actively worked to
                    restore world peace and save lives throughout the year.
                    <br />
                    <br />
                    President Xi Jinping attended three major diplomatic events at home – the
                    China-Arab States Cooperation Forum, the conference marking the 70th anniversary
                    of the Five Principles of Peaceful Coexistence, and the Beijing Summit of the
                    Forum on China-Africa Cooperation, made four key overseas visits – to Europe, to
                    Central Asia, for the BRICS Summit, and to Latin America, and attended several
                    multilateral summits over the course of the year.
                    <br />
                    <br />
                    As a "stable, positive and progressive force" in the international community,
                    China will always stay on the path of peaceful development, said President Xi
                    after accepting credentials presented by 28 ambassadors to China on December 12,
                    2024.
                </div>
            </div>
        </div>
    )
}

export default Greetings
